import {AdminUserType} from './Beneficiaries/AdminUserType';

export enum BeneficiariesRole {
  Undetermined,
  Admin,
}

export class UndeterminedBeneficiariesUserType {
  public readonly key = 'UndeterminedBeneficiariesUserType';
  public readonly beneficiariesRole = BeneficiariesRole.Undetermined;
}

export class InvalidBeneficiariesUserType {
  public readonly key = 'InvalidBeneficiariesUserType';
  public readonly value = new UndeterminedBeneficiariesUserType();
}

export class ValidBeneficiariesUserType {
  public readonly key = 'ValidBeneficiariesUserType';

  constructor(public readonly value: AdminUserType) {}
}

export type BeneficiariesUserType =
  | ValidBeneficiariesUserType
  | InvalidBeneficiariesUserType
  | UndeterminedBeneficiariesUserType;

type BeneficiariesUserTypeOptions<TReturn> = {
  Admin: (adminUserType: AdminUserType) => TReturn;
  Undetermined: () => TReturn;
};

export const matchBeneficiariesUserType = <TReturn>(
  beneficiariesUserType: ValidBeneficiariesUserType['value'] | InvalidBeneficiariesUserType['value'],
  options: BeneficiariesUserTypeOptions<TReturn>
): TReturn => {
  switch (beneficiariesUserType.key) {
    case 'UndeterminedBeneficiariesUserType':
      return options.Undetermined();
    case 'AdminUserType':
      return options.Admin(beneficiariesUserType);
  }
};
